(function() {
  'use strict';

  var colorSlideMap = {
    'aurelia-oversized-shirt':        { 'Weiß': 0, 'Babyblau': 2, 'Washed Grey': 4 },
    'palm-paradise-oversized-shirt':  { 'Babyblau': 0, 'Weiß': 2, 'Washed Grey': 4, 'Schwarz': 6 },
    'aperto-oversized-shirt':         { 'Weiß': 0, 'Babyblau': 2, 'Washed Grey': 4 },
    'marea-oversized-shirt':          { 'Babyblau': 0, 'Weiß': 2, 'Natural Raw': 4 },
    'azzurra-oversized-shirt':        { 'Babyblau': 0, 'Weiß': 2, 'Natural Raw': 4, 'Washed Grey': 6 },
    'summer-society-oversized-shirt': { 'Weiß': 0, 'Babyblau': 2, 'Natural Raw': 4 },
    'saint-angel-oversized-hoodie':   { 'Weiß': 0, 'Schwarz': 2 },
    'blessed-oversized-hoodie':       { 'Weiß': 0, 'Natural Raw': 2 },
    'smoky-oversized-hoodie':         { 'Weiß': 0, 'Natural Raw': 2, 'Schwarz': 4 },
    'beyond-the-veil-oversized-hoodie': { 'Schwarz': 0, 'Weiß': 2, 'Natural Raw': 4 },
    'entangled-oversized-hoodie':       { 'Schwarz': 0, 'Weiß': 2, 'Natural Raw': 4 },
    'ashes-in-snow-oversized-hoodie':   { 'Weiß': 0, 'Schwarz': 2, 'Natural Raw': 4 },
    'silent-desire-oversized-hoodie':   { 'Weiß': 0, 'Schwarz': 2, 'Natural Raw': 4 },
    'be-your-oversized-shirt':        { 'Weiß': 0, 'Babyblau': 2, 'Natural Raw': 4, 'Washed Black': 6, 'Washed Grey': 8 },
    'blessed-oversized-shirt':        { 'Schwarz': 0, 'Washed Black': 2 },
    'summer-oversized-shirt':         { 'Babyblau': 0, 'Schwarz': 2, 'Washed Black': 4, 'Washed Grey': 6 },
    'fearless-oversized-shirt':       { 'Washed Black': 0, 'Washed Grey': 2 },
    'hustle-oversized-shirt':         { 'Schwarz': 0, 'Washed Black': 2 },
    'challenge-oversized-shirt':      { 'Washed Black': 0, 'Weiß': 2 },
    'hypnotic-t-shirt':               { 'French Navy': 0, 'Schwarz': 2, 'Heather Grey': 4, 'Natural Raw': 6, 'Weiß': 8 },
    'scape-t-shirt':                  { 'French Navy': 0, 'Schwarz': 2 },
    'pray-t-shirt':                   { 'French Navy': 0, 'Schwarz': 2, 'Weiß': 4 },
    'faith-t-shirt':                  { 'French Navy': 0, 'Schwarz': 2 }
  };

  if (!window.location.pathname.includes('/products/')) return;

  function getProductHandle() {
    var parts = window.location.pathname.split('/');
    var idx = parts.indexOf('products');
    if (idx === -1) return '';
    return (parts[idx + 1] || '').split('?')[0];
  }

  function getIndexForColor(color) {
    var handle = getProductHandle();
    var map = colorSlideMap[handle];
    if (!map || color === undefined) return null;
    var index = map[color];
    return index !== undefined ? index : null;
  }

  var pendingIndex = null;

  // Warte auf neue media-gallery via MutationObserver
  var observer = new MutationObserver(function(mutations) {
    if (pendingIndex === null) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.tagName && node.tagName.toLowerCase() === 'media-gallery') {
          var idx = pendingIndex;
          pendingIndex = null;
          var attempts = 0;
          (function(targetIdx) {
            function trySelect() {
              var gallery = document.querySelector('media-gallery');
              if (gallery && gallery.slideshow && typeof gallery.slideshow.select === 'function') {
                gallery.slideshow.select(targetIdx, undefined, { animate: false });
              } else if (attempts++ < 20) {
                requestAnimationFrame(trySelect);
              }
            }
            requestAnimationFrame(trySelect);
          })(idx);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function(e) {
    var label = e.target.closest('label, .variant-option__button-label');
    if (!label) return;
    var input = label.querySelector('input[type="radio"]');
    if (!input) return;
    var fieldset = label.closest('fieldset');
    if (!fieldset) return;
    var legend = fieldset.querySelector('legend');
    if (!legend) return;
    var legendText = legend.textContent.trim().toLowerCase();
    if (!legendText.includes('farbe') && !legendText.includes('color')) return;
    var idx = getIndexForColor(input.value);
    if (idx !== null) pendingIndex = idx;
  }, true);

})();
